/* unplugin-vue-components disabled */import { render } from "./Url.vue?vue&type=template&id=09bbba0c&scoped=true"
import script from "./Url.vue?vue&type=script&lang=js"
export * from "./Url.vue?vue&type=script&lang=js"

import "./Url.vue?vue&type=style&index=0&id=09bbba0c&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09bbba0c"]])

export default __exports__